:host {
  position: absolute;
  width: 100%;
  bottom: 90px;
}

.toast {
  position: relative;
  display: flex;
  gap: 8px;
  background-color: var(--error-toast-background-color);
  color: var(--error-toast-color);
  padding: 0;
  border-radius: 12px;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.5s ease,
    visibility 0.5s ease;
  z-index: 9999;

  &__show {
    margin: 0 24px;
    height: auto;
    padding: 16px;
    animation: toastAnimation 3.5s forwards;
  }

  &__icon {
    display: flex;
  }

  &__error {
    display: flex;
    flex-direction: column;
  }

  &__message {
    word-break: break-all;
    --rasa-text-font-weight: bold;
  }

  &__description {
    word-break: break-all;
  }
}

@keyframes toastAnimation {
  0% {
    bottom: -16px;
    opacity: 0;
    visibility: hidden;
  }
  10%,
  80% {
    bottom: 0;
    opacity: 1;
    visibility: visible;
  }
  90% {
    bottom: 0;
    opacity: 1;
    visibility: visible;
  }
  100% {
    bottom: -16px;
    opacity: 0;
    visibility: hidden;
  }
}
